import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { InputBase as InputBaseMemoized } from '../InputBase/InputBase.js';

/** Dropdown is used for revealing a list of options or commands. */
var DropdownLegacy = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InputBaseMemoized, _extends({
    trailingAsset: {
      id: 'line.arrow.thin-dropdown'
    }
  }, props, {
    type: "select",
    ref: ref
  }));
});
var DropdownLegacyMemoized = /*#__PURE__*/React.memo(DropdownLegacy);
DropdownLegacyMemoized.displayName = 'DropdownLegacy';

export { DropdownLegacyMemoized as DropdownLegacy };
//# sourceMappingURL=DropdownLegacy.js.map
